import React from "react";
import Footer from "../../Footer/footer";
import { Outlet, useLocation } from "react-router-dom";
// import artboard from "../../../assets/images/Artboard.png";
import artboard1 from "../../../assets/images/Artboard1.png";
import bitanicaText from "../../../assets/images/bitanicaText.png";
// import boardText from "../../../assets/images/boardText.png";
// import logoText from "../../../assets/images/logoText.png";
import logoText1 from "../../../assets/images/logoText1bk.png";
import clickEarn from "../../../assets/images/clickEarn.png";

// css
import styles from "./mainlayout.module.scss";
import Header from "../../Header";

const MainLayout = () => {
  const { pathname } = useLocation();

  const noFooterRoutes = [
    "/jackpot",
    "/shop-history",
    "/roadmap",
    "/jackpot-history",
    "/success",
  ];

  const nonHeader = [
    "/task",
    "/wallet",
    "/roadmap",
    "/shop",
    "/friends",
    "/refferals",
    "/earnings",
    "/payments",
    "/jackpot",
    "/jackpot-history",
    "/success",
  ];
  return (
    <>
      <main>
        <div
          className="d-flex align-items-start justify-content-center mx-auto px-lg-3"
          style={{ maxWidth: 1280 }}
        >
          <div
            className={`${styles.bannerContnt} left w-100 d-none d-md-block`}
          >
            <div className="py-2">
              <div className={`${styles.cardCstm} text-center`}>
                <img
                  src={bitanicaText}
                  alt=""
                  className="img-fluid w-100 rounded"
                />
              </div>
            </div>
            <div className="py-2">
              <div className={`${styles.cardCstm} text-center`}>
                <img
                  src={artboard1}
                  alt=""
                  className="img-fluid w-100 rounded"
                />
              </div>
            </div>
            {/* <div className="py-2">
                                <div className={`${styles.cardCstm} p-3 text-center`}>
                                    <img src={boardText} alt="" className="img-fluid w-100 rounded" style={{ background: "#0C0C0C" }} />
                                </div>
                            </div> */}
          </div>
          <div
            className={`${styles.center} mainContentWrpper flex-shrink-0 mx-auto position-relative`}
            style={{ width: 430 }}
          >
            {!nonHeader.some((path) => pathname.startsWith(path)) ? (
              <Header />
            ) : null}
            <Outlet />
            {!noFooterRoutes.some((path) => pathname.startsWith(path)) ? (
              <Footer />
            ) : null}
          </div>
          <div
            className={`${styles.bannerContnt} right w-100 d-none d-md-block`}
          >
            <div className="py-2">
              <div
                className={`${styles.cardCstm} text-center position-relative`}
              >
                <img
                  src={logoText1}
                  alt=""
                  className="img-fluid w-100 rounded"
                />
                {/* <Button
                  onClick={() =>
                    window.open(
                      "https://bitanica.gitbook.io/giveaway",
                      "_blank"
                    )
                  }
                  className={`${styles.linkBtn} position-absolute d-inline-flex mx-auto align-items-center justify-content-center w-100 fw-bold text-white`}
                  style={{
                    background: "#242AFC",
                    left: 0,
                    right: 0,
                    bottom: 20,
                    maxWidth: 170,
                  }}
                >
                  VIEW RULES
                </Button> */}
              </div>
            </div>
            <div className="py-2">
              <div className={`${styles.cardCstm} text-center`}>
                <img
                  src={clickEarn}
                  alt=""
                  className="img-fluid w-100 rounded"
                />
              </div>
            </div>
            <div className="py-2">
              <div className={`${styles.cardCstm} p-3 text-center`}>
                <ul className="list-unstyled ps-0 mb-0 d-flex gap-10 p-2 align-items-center justify-content-center">
                  <li className="">
                    <a
                      href="https://x.com/Bitanica_com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {twitter}
                    </a>
                  </li>
                  <li className="">
                    <a
                      href="https://discord.com/invite/RdSGEbQQ25"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {discord}
                    </a>
                  </li>
                  <li className="">
                    <a
                      href="https://www.instagram.com/bitanica_com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {instagram}
                    </a>
                  </li>
                  <li className="">
                    <a
                      href="https://www.facebook.com/bitanicacom"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {fb}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default MainLayout;

const twitter = (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="23" cy="23" r="23" fill="white" />
    <path
      d="M27.2375 29.3328H28.7547L18.9489 16.3621H17.3198L27.2375 29.3328ZM28.2013 14.8076H30.9434L24.9493 21.6536L32.0005 30.9744H26.4789L22.1574 25.3222L17.2141 30.9744H14.4658L20.8765 23.6496L14.1113 14.8076H19.7697L23.6746 19.9748L28.1951 14.8076H28.2013Z"
      fill="#0F0F13"
    />
  </svg>
);

const discord = (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="23" cy="23" r="23" fill="white" />
    <path
      d="M27.2375 29.3331H28.7547L18.9489 16.3624H17.3198L27.2375 29.3331ZM28.2013 14.8079H30.9434L24.9493 21.6539L32.0005 30.9746H26.4789L22.1574 25.3225L17.2141 30.9746H14.4658L20.8765 23.6498L14.1113 14.8079H19.7697L23.6746 19.975L28.1951 14.8079H28.2013Z"
      fill="#0F0F13"
    />
    <circle cx="23" cy="23" r="23" fill="white" />
    <path
      d="M33 15.8906C32.9942 15.2572 32.7389 14.6517 32.2896 14.2053C31.8403 13.7589 31.2331 13.5076 30.5998 13.5059L15.3827 13.46C14.7514 13.461 14.1463 13.712 13.6994 14.1579C13.2526 14.6038 13.0004 15.2084 12.998 15.8397V31.5384C13.0002 31.8474 13.064 32.1529 13.1855 32.4369C13.3071 32.721 13.4841 32.978 13.7061 33.1929C13.9281 33.4078 14.1907 33.5763 14.4786 33.6886C14.7664 33.8009 15.0738 33.8546 15.3827 33.8468H28.3842L27.7581 31.7337L33 36.5391V15.8906ZM26.3015 28.549C26.3015 28.549 25.8814 28.0517 25.5326 27.6209C26.3732 27.4235 27.1187 26.9392 27.6407 26.2514C27.2215 26.528 26.7725 26.7567 26.3023 26.9333C25.7574 27.1593 25.1903 27.3276 24.6103 27.4355C23.6128 27.6175 22.5901 27.6122 21.5946 27.4199C21.0097 27.3137 20.4374 27.1471 19.8869 26.9226C19.5949 26.8099 19.3107 26.678 19.036 26.5279C18.9999 26.5074 18.9638 26.4918 18.9334 26.4713C18.903 26.4508 18.8973 26.4458 18.8825 26.4458C18.6724 26.3277 18.5592 26.2505 18.5592 26.2505C19.0604 26.9251 19.7798 27.4053 20.5951 27.6094C20.2463 28.0509 19.8155 28.5581 19.8155 28.5581C19.1251 28.5775 18.4403 28.428 17.8209 28.1223C17.2015 27.8167 16.6662 27.3643 16.2615 26.8044C16.3012 24.468 16.875 22.1717 17.9388 20.0912C18.8767 19.3642 20.0155 18.9433 21.2007 18.8857L21.3189 19.0244C20.2009 19.2932 19.1578 19.8104 18.2671 20.5376C18.2671 20.5376 18.5239 20.394 18.9539 20.2093C19.7931 19.8349 20.6833 19.5877 21.5954 19.4757C21.6615 19.4638 21.7285 19.457 21.7956 19.4552C22.5767 19.3544 23.3669 19.3459 24.1499 19.4298C25.3774 19.5729 26.5664 19.9489 27.653 20.5376C26.8049 19.8444 25.8162 19.3437 24.7555 19.0704L24.9147 18.8857C26.101 18.9423 27.2405 19.3651 28.1766 20.0961C29.2414 22.1763 29.8152 24.4728 29.8538 26.8094C29.445 27.3633 28.9087 27.8107 28.2904 28.1135C27.672 28.4163 26.9898 28.5657 26.3015 28.549Z"
      fill="#191922"
    />
    <path
      d="M20.8867 23.1741C20.6305 23.156 20.3747 23.2154 20.1527 23.3446C19.9306 23.4738 19.7526 23.6668 19.6417 23.8985C19.5308 24.1303 19.4923 24.39 19.531 24.644C19.5697 24.8979 19.6839 25.1344 19.8588 25.3225C20.0337 25.5107 20.2612 25.6419 20.5117 25.6991C20.7621 25.7562 21.024 25.7367 21.2632 25.643C21.5024 25.5494 21.7079 25.3859 21.853 25.1739C21.998 24.9619 22.076 24.7111 22.0766 24.4542C22.0832 24.2919 22.0576 24.1298 22.0012 23.9774C21.9449 23.8251 21.8589 23.6853 21.7483 23.5663C21.6377 23.4473 21.5046 23.3514 21.3567 23.2841C21.2089 23.2167 21.0491 23.1794 20.8867 23.1741Z"
      fill="#191922"
    />
    <path
      d="M25.1381 23.174C24.8815 23.1547 24.625 23.2132 24.4021 23.3417C24.1792 23.4703 24.0002 23.663 23.8884 23.8948C23.7765 24.1265 23.7371 24.3866 23.7752 24.6411C23.8133 24.8955 23.9272 25.1327 24.102 25.3215C24.2768 25.5103 24.5044 25.6422 24.7552 25.6998C25.006 25.7574 25.2683 25.7381 25.508 25.6445C25.7477 25.5509 25.9537 25.3873 26.099 25.175C26.2444 24.9626 26.3224 24.7115 26.323 24.4541C26.3296 24.2922 26.3041 24.1306 26.2481 23.9785C26.1921 23.8264 26.1065 23.6869 25.9964 23.5679C25.8863 23.449 25.7538 23.353 25.6065 23.2854C25.4592 23.2178 25.3 23.1799 25.1381 23.174Z"
      fill="#191922"
    />
  </svg>
);

const fb = (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="23" cy="23" r="23" fill="white" />
    <path
      d="M33.9998 23.0732C34.0085 20.9692 33.4135 18.9068 32.2855 17.1307C31.1575 15.3546 29.5437 13.9393 27.6356 13.0526C25.7275 12.1659 23.6052 11.845 21.5203 12.1281C19.4353 12.4111 17.4753 13.2862 15.8727 14.6495C14.2701 16.0128 13.0921 17.8071 12.4784 19.8197C11.8647 21.8323 11.8411 23.9786 12.4104 26.0042C12.9797 28.0298 14.118 29.8496 15.6902 31.2478C17.2625 32.646 19.2028 33.5639 21.281 33.8927V26.2346H18.49V23.0652H21.281V20.6532C21.281 17.9084 22.9222 16.3882 25.4382 16.3882C26.2627 16.3999 27.0852 16.4717 27.8993 16.6031V19.3017H26.5111C26.2752 19.27 26.0351 19.2918 25.8088 19.3654C25.5824 19.439 25.3755 19.5626 25.2034 19.7271C25.0312 19.8915 24.8983 20.0926 24.8145 20.3153C24.7306 20.5381 24.6979 20.7769 24.7188 21.014V23.0674H27.7665L27.2803 26.2368H24.7188V33.8971C27.3006 33.492 29.6532 32.1796 31.3543 30.1958C33.0554 28.2119 33.9934 25.6865 33.9998 23.0732Z"
      fill="black"
    />
  </svg>
);

const instagram = (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="23" cy="23" r="23" fill="#5865F2" />
    <g clip-path="url(#clip0_1_5780)">
      <mask
        id="mask0_1_5780"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="46"
        height="46"
      >
        <path
          d="M22.9982 45.9965C35.6998 45.9965 45.9965 35.6998 45.9965 22.9982C45.9965 10.2967 35.6998 0 22.9982 0C10.2967 0 0 10.2967 0 22.9982C0 35.6998 10.2967 45.9965 22.9982 45.9965Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1_5780)">
        <path
          d="M23.0088 0.00708008C13.4091 0.00708008 10.6007 0.0176914 10.056 0.0636737C8.08581 0.22638 6.85843 0.537645 5.52495 1.20262C4.49565 1.7155 3.68565 2.3062 2.88273 3.13741C1.42191 4.65129 0.537633 6.51535 0.219294 8.72957C0.0636618 9.80485 0.0176794 10.0241 0.0106052 15.5173C0.00706815 17.3459 0.0106052 19.7547 0.0106052 22.9876C0.0106052 32.5802 0.0212166 35.3852 0.0671989 35.9299C0.226368 37.847 0.527022 39.0531 1.1637 40.3725C2.38046 42.898 4.70434 44.7938 7.44205 45.5013C8.39 45.7453 9.43698 45.8797 10.7811 45.9434C11.3506 45.9682 17.1549 45.9859 22.9629 45.9859C28.7708 45.9859 34.5787 45.9788 35.134 45.9505C36.6903 45.8762 37.5958 45.7559 38.5933 45.4977C41.3487 44.7868 43.6301 42.9192 44.8717 40.3583C45.4942 39.0708 45.8125 37.8187 45.9575 36.0006C45.9894 35.6045 46 29.2872 46 22.9806C46 16.6739 45.9858 10.3672 45.954 9.97109C45.809 8.12473 45.4942 6.8832 44.8469 5.57094C44.3163 4.49566 43.7327 3.69628 42.8767 2.87567C41.3558 1.42192 39.4953 0.537645 37.2775 0.219306C36.2022 0.0636737 35.99 0.0176914 30.4933 0.00708008H23.0088Z"
          fill="white"
        />
      </g>
      <path
        d="M23 13C20.2854 13 19.9437 13.0125 18.8771 13.0604C17.8125 13.1083 17.0854 13.2771 16.45 13.525C15.7917 13.7813 15.2354 14.1229 14.6792 14.6771C14.1229 15.2333 13.7812 15.7917 13.525 16.4479C13.2771 17.0833 13.1083 17.8104 13.0604 18.875C13.0125 19.9417 13 20.2833 13 22.9979C13 25.7125 13.0125 26.0542 13.0604 27.1208C13.1104 28.1854 13.2771 28.9125 13.525 29.5479C13.7812 30.2063 14.1229 30.7625 14.6792 31.3188C15.2354 31.875 15.7917 32.2167 16.45 32.4729C17.0854 32.7208 17.8125 32.8896 18.8771 32.9375C19.9437 32.9854 20.2854 32.9979 23 32.9979C25.7146 32.9979 26.0562 32.9854 27.1229 32.9375C28.1875 32.8896 28.9146 32.7208 29.5521 32.4729C30.2104 32.2167 30.7667 31.875 31.3229 31.3188C31.8792 30.7625 32.2208 30.2042 32.4771 29.5479C32.7229 28.9125 32.8917 28.1854 32.9417 27.1208C32.9896 26.0542 33.0021 25.7146 33.0021 22.9979C33.0021 20.2813 32.9896 19.9417 32.9417 18.875C32.8917 17.8104 32.7229 17.0833 32.4771 16.4479C32.2208 15.7896 31.8792 15.2333 31.3229 14.6771C30.7667 14.1208 30.2104 13.7792 29.5521 13.525C28.9146 13.2771 28.1875 13.1083 27.1229 13.0604C26.0562 13.0125 25.7167 13 23 13ZM22.1021 14.8021C22.3687 14.8021 22.6646 14.8021 23 14.8021C25.6708 14.8021 25.9854 14.8125 27.0417 14.8604C28.0167 14.9042 28.5458 15.0687 28.8979 15.2042C29.3646 15.3854 29.6979 15.6021 30.0479 15.9521C30.3979 16.3021 30.6146 16.6354 30.7958 17.1021C30.9333 17.4542 31.0958 17.9833 31.1396 18.9583C31.1875 20.0125 31.1979 20.3292 31.1979 22.9979C31.1979 25.6667 31.1875 25.9833 31.1396 27.0375C31.0958 28.0125 30.9312 28.5417 30.7958 28.8938C30.6146 29.3604 30.3979 29.6917 30.0479 30.0417C29.6979 30.3917 29.3646 30.6083 28.8979 30.7896C28.5458 30.9271 28.0167 31.0896 27.0417 31.1333C25.9875 31.1813 25.6708 31.1917 23 31.1917C20.3292 31.1917 20.0125 31.1813 18.9583 31.1333C17.9833 31.0875 17.4542 30.925 17.1021 30.7896C16.6354 30.6083 16.3021 30.3917 15.9521 30.0417C15.6021 29.6917 15.3854 29.3583 15.2042 28.8917C15.0667 28.5396 14.9042 28.0104 14.8604 27.0354C14.8125 25.9813 14.8021 25.6646 14.8021 22.9938C14.8021 20.3229 14.8125 20.0083 14.8604 18.9542C14.9042 17.9792 15.0687 17.45 15.2042 17.0979C15.3854 16.6313 15.6021 16.2979 15.9521 15.9479C16.3021 15.5979 16.6354 15.3813 17.1021 15.2C17.4542 15.0625 17.9833 14.9 18.9583 14.8542C19.8812 14.8125 20.2375 14.8 22.1021 14.7979V14.8021ZM28.3375 16.4625C27.675 16.4625 27.1375 17 27.1375 17.6625C27.1375 18.325 27.675 18.8625 28.3375 18.8625C29 18.8625 29.5375 18.325 29.5375 17.6625C29.5375 17 29 16.4625 28.3375 16.4625ZM23 17.8646C20.1646 17.8646 17.8646 20.1646 17.8646 23C17.8646 25.8354 20.1646 28.1354 23 28.1354C25.8354 28.1354 28.1354 25.8375 28.1354 23C28.1354 20.1625 25.8375 17.8646 23 17.8646ZM23 19.6667C24.8417 19.6667 26.3333 21.1583 26.3333 23C26.3333 24.8417 24.8417 26.3333 23 26.3333C21.1583 26.3333 19.6667 24.8417 19.6667 23C19.6667 21.1583 21.1583 19.6667 23 19.6667Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_5780">
        <rect width="46" height="46" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
